// extracted by mini-css-extract-plugin
export default {"overflowing-flex-box":"eJkn0","inner":"AUafi","scrollable":"Y0DcS"};